import { FixedScreenHeaderStack } from '~/common/components/defaultUIComponents';
import { Heading } from '~/common/components/defaultUIComponents/Heading';
import EmployeeApi from '~/common/api/zeiterfassungServerApi/EmployeeApi';
import { Select } from '~/common/components/defaultUIComponents/Select';
import { useDayplanService } from '~/common/services/DayplanService';
import { ApiSuccessCallback } from '~/common/services/callback';
import { Todo } from '~/common/entities/Dayplan/DayplanTypes';
import JobTile from '~/common/components/JobTile';
import { Divider, Stack } from '@chakra-ui/react';
import React from 'react';

const Dayplan = () => {
  const dayplanService = useDayplanService();
  const {
    todosOfEmployeeToShow,
    setTodosOfEmployeeToShow,
    employeeIdToShow,
    setEmployeeIdToShow,
  } = dayplanService;

  const [employeeQueryResult] = EmployeeApi.hooks.useEmployeeQuery();
  const employees = employeeQueryResult.data || [];

  const setTodosOfEmployeeFromServer = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const onSuccess: ApiSuccessCallback<Todo[]> = (data?: Todo[]) => {
      setTodosOfEmployeeToShow(data!);
    };
    const tmpEmployeeId = event.currentTarget.value;
    if (tmpEmployeeId !== '') {
      const employee = employees.find((e) => e.id == tmpEmployeeId);
      dayplanService.getTodosOfEmployee(employee!, onSuccess);
      setEmployeeIdToShow(tmpEmployeeId);
    } else {
      setTodosOfEmployeeToShow([]);
      setEmployeeIdToShow('');
    }
  };

  return (
    <>
      <FixedScreenHeaderStack>
        <Heading mb={3}>dayplan.heading</Heading>
        <Select
          placeholder="dayplan.selectEmployee.placeholder"
          onChange={setTodosOfEmployeeFromServer}
        >
          {employees.map((employee) => (
            <option key={employee.id} value={employee.id}>
              {employee.user.first_name + ' ' + employee.user.last_name}
            </option>
          ))}
        </Select>
      </FixedScreenHeaderStack>
      <Stack mt={28}>
        {todosOfEmployeeToShow !== null && employeeIdToShow != ''
          ? todosOfEmployeeToShow.map((todo) => (
              <React.Fragment key={todo.id}>
                <JobTile
                  key={todo.id}
                  job={todo.job}
                  todoAmount={todo.amount}
                  employeeId={employeeIdToShow}
                  todo={todo}
                />
                <Divider />
              </React.Fragment>
            ))
          : null}
      </Stack>
    </>
  );
};

export default Dayplan;
